export const SCROLL_LOCK = 'scroll-lock';
